export class Debouncer {
    func;
    delayMs;
    #timerId;
    constructor(func, delayMs) {
        this.func = func;
        this.delayMs = delayMs;
    }
    execute(input) {
        window.clearTimeout(this.#timerId);
        this.#timerId = window.setTimeout(() => {
            this.#timerId = undefined;
            this.func(input);
        }, this.delayMs);
    }
}
